var exports = {
  "kL": "CreateDMBottomSheet.module__container___UXNQRl",
  "XG": "CreateDMBottomSheet.module__scroller___UXNQRl",
  "Qs": "CreateDMBottomSheet.module__content___UXNQRl",
  "h_": "CreateDMBottomSheet.module__description___UXNQRl",
  "ov": "CreateDMBottomSheet.module__friendSelector___UXNQRl",
  "qr": "CreateDMBottomSheet.module__footer___UXNQRl",
  "x7": "CreateDMBottomSheet.module__cancelButton___UXNQRl",
  "Tf": "CreateDMBottomSheet.module__createButton___UXNQRl",
};

module.exports = exports;
